import cn from 'classnames';
import { IProductMedia } from 'models/IProductMedia';
import styles from './styles.scss';
import Image from 'components/Shared/Image';
import { memo } from 'react';
import { NO_ELEMENT } from 'utils';
import { useImageAttributeContext } from 'views/ProductPage/configurators/imageAttributeContext';
import { isImage, isVideo } from 'views/ProductPage/selector';
import { VideoThumbnailIcon } from './VideoThumbnailIcon';

const THUMB = 80;
const THUMB_DIMENSIONS = {
  height: THUMB,
  width: THUMB
};

interface OwnProps {
  media: IProductMedia;
  onClick?: (media: IProductMedia) => void;
  className?: string;
}

export const ProductMediaThumbnail = memo<OwnProps>(({ className, media, onClick }) => {
  const { resetProductImage } = useImageAttributeContext();
  const handleClick = () => {
    resetProductImage();
    onClick && onClick(media);
  };

  if (isImage(media)) {
    return (
      <div className={cn(className, styles.mediaThumbnailWrapper)}>
        <Image
          paddingBottom
          className={styles.mediaThumbnail}
          onClick={handleClick}
          {...media}
          {...THUMB_DIMENSIONS}
        />
      </div>
    );
  }

  if (isVideo(media)) {
    return (
      <div className={cn(className, styles.mediaThumbnailWrapper)} onClick={handleClick}>
        <VideoThumbnailIcon />
        <img src={media.thumbnailUrl} className={styles.mediaThumbnail} />
      </div>
    );
  }
  return NO_ELEMENT;
});
